<template>
  <div class="lp-adm-typing-text-contianer">
    <input type="text" class="typing-text-input" :value="keyword" @input="typeText">
  </div>
</template>

<script>
export default {
  props: ['val'],
  date() {
    return {
      keyword: ''
    }
  },
  created() {
    this.keyword = this.val;
  },
  methods: {
    typeText(e) {
      this.keyword = e.target.value;
    }
  }
}
</script>

<style lang="stylus" type="stylus" scoped>
.typing-text-input
  border 1px solid #aaa
  border-radius 10px
  padding 8px 10px
  width 140px
  font-size .85rem
  color #064160
  font-weight bold



</style>